"use client";

import { ShoppingCart } from "@ellaandil/ui";
import { twMerge } from "tailwind-merge";
import { Button } from "@/components/ui/Button";
import { Typography } from "@/components/ui/Typography";
import { useTranslations } from "@/i18n/client";

export interface EmptyCartProps {
	onContinue: () => void;
	className?: string;
}

export const EmptyCart = ({ onContinue, className }: EmptyCartProps) => {
	const t = useTranslations("cart");
	return (
		<div
			className={twMerge(
				"flex h-full flex-col items-center justify-center gap-grid-component-spacing-2xl py-grid-component-spacing-2xl text-text-dark-text-1",
				className,
			)}
		>
			<ShoppingCart className="size-8" />
			<div className="flex flex-col items-center gap-grid-component-spacing-2xs text-center">
				<Typography variant="heading-lg" as="h3">
					{t("empty.title")}
				</Typography>
				<Typography variant="body-md-reg">{t("empty.subtitle")}</Typography>
			</div>
			<Button variant="solid" color="primary" size="large" onClick={onContinue}>
				{t("empty.continue")}
			</Button>
		</div>
	);
};
